import { render, staticRenderFns } from "./Form1_Persona.vue?vue&type=template&id=385c1893"
import script from "./Form1_Persona.vue?vue&type=script&lang=js"
export * from "./Form1_Persona.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('385c1893')) {
      api.createRecord('385c1893', component.options)
    } else {
      api.reload('385c1893', component.options)
    }
    module.hot.accept("./Form1_Persona.vue?vue&type=template&id=385c1893", function () {
      api.rerender('385c1893', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flujo/Formularios/Formularios1/HIPOTECALO/Form1_Persona.vue"
export default component.exports